import request from '@/util/request'

export function getAccountInfo(query) {
  return request({
    url: '/capital/accountInfo',
    method: 'get',
    params: query,
  })
}

export function getAccountFlow(query) {
  return request({
    url: '/capital/flow',
    method: 'get',
    params: query,
  })
}

export function rechargeApply(data) {
  return request({
    url: '/capital/rechargeApply',
    method: 'post',
    data,
  })
}
